export enum UserRole {
  INITIAL = 'INITIAL',
  MEDICAL_DISCONNECTED = 'MEDICAL_DISCONNECTED',
  NONE = 'NONE',
  PARTIAL = 'PARTIAL',
  UNVERIFIED = 'UNVERIFIED',
  USER = 'USER',
  VERIFIED = 'VERIFIED',
}
